import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';

import UserItem from './UserColumnItem';

const UserColumnList = ({ children, fields, mapZolaColumn, setHeight, unmapZolaColumn }) => {
  const userCol = useRef();
  useEffect(() => {
    setHeight(userCol.current.clientHeight);
  }, []);

  const columns = Object.keys(fields);

  return (
    <div className="user-list" ref={userCol}>
      <div className="user-list__title title">Your List</div>
      <div className="user-list__list">
        {columns.map((colName, i) => {
          const { name, target } = fields[colName];
          return (
            <UserItem
              fieldName={name}
              key={name + i}
              target={target}
              mapZolaColumn={mapZolaColumn}
              unmapZolaColumn={unmapZolaColumn}
            />
          );
        })}
      </div>
      {children}
    </div>
  );
};

UserColumnList.propTypes = {
  children: PropTypes.node,
  fields: PropTypes.objectOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      target: PropTypes.string,
    })
  ).isRequired,
  mapZolaColumn: PropTypes.func,
  setHeight: PropTypes.func,
  unmapZolaColumn: PropTypes.func,
};

export default UserColumnList;



// WEBPACK FOOTER //
// ./src/components/manage/guestlist/upload/UserColumnList.jsx